import { render, staticRenderFns } from "./Importacao.vue?vue&type=template&id=8121a2bc&lang=html&"
import script from "./Importacao.vue?vue&type=script&lang=js&"
export * from "./Importacao.vue?vue&type=script&lang=js&"
import style0 from "./Importacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/importacao/Importacao.vue
// module id = 1410
// module chunks = 28